module.exports = __webpack_public_path__ + "static/media/img-devops-aws-black.237bd9a1.png";